import { ROLES } from '../utils/roleUtils';

// Import pages from the new organized structure
import {
  LoginPage,
  SignupPage,
  ForgotPasswordPage,
  AdminAnalyticsPage,
  AdminActivityPage,
  CallDetailsPage,
  UserManagementPage,
  CallDemoPage
} from '../pages';

// Agent-specific components removed - handled by call-service

// Call routes removed - handled by call-service

// Public routes (no authentication required)
export const publicRoutes = [
  {
    path: '/login',
    component: LoginPage,
    exact: true
  },
  {
    path: '/signup',
    component: SignupPage,
    exact: true
  },
  {
    path: '/forgot-password',
    component: ForgotPasswordPage,
    exact: true
  },
  // Call routes removed - these are handled by call-service
  // /call/:agentId and /fast-call/:agentId are served by call-service
  {
    path: '/demo/call',
    component: CallDemoPage,
    exact: true
  }
];

// Protected app sections with role-based access control (Admin Only)
export const appSections = {
  // Analytics - Admin and Team Lead
  analytics: {
    component: AdminAnalyticsPage,
    allowedRoles: [ROLES.ADMIN, ROLES.TEAM_LEAD]
  },

  // Activity - Admin and Team Lead  
  activity: {
    component: AdminActivityPage,
    allowedRoles: [ROLES.ADMIN, ROLES.TEAM_LEAD]
  },

  // User Management - Admin only
  'user-management': {
    component: UserManagementPage,
    allowedRoles: [ROLES.ADMIN]
  },

  // Call Details - Admin can view all call data
  'call-details': {
    component: CallDetailsPage,
    allowedRoles: [ROLES.ADMIN]
  }
};

// Default routes for each role (Admin Only Dashboard)
export const defaultRoutes = {
  [ROLES.ADMIN]: 'analytics',
  [ROLES.TEAM_LEAD]: 'analytics' // Team leads can view analytics in dashboard
  // AGENT roles should use call-service, not dashboard-service
};

// Helper function to get component for section based on user role
export function getSectionComponent(section, userRole) {
  const sectionConfig = appSections[section];
  
  if (!sectionConfig) {
    return null;
  }

  // Check if user has access to this section
  if (!sectionConfig.allowedRoles.includes(userRole)) {
    return null;
  }

  // Return role-specific component if available, otherwise default component
  return sectionConfig.roleSpecificComponents?.[userRole] || sectionConfig.component;
}

// Helper function to check if section requires special handling
export function getSectionConfig(section) {
  return appSections[section] || null;
}

// Get all available sections for a given role
export function getAvailableSections(userRole) {
  return Object.keys(appSections).filter(section => 
    appSections[section].allowedRoles.includes(userRole)
  );
}

// Check if user can access a specific section
export function canAccessSection(section, userRole) {
  const sectionConfig = appSections[section];
  return sectionConfig && sectionConfig.allowedRoles.includes(userRole);
} 